import React from 'react';
import { RecordGridActionsAction, RecordGridActionsMenuItem } from '../types';
import { IconButton, Tooltip } from '@mui/material';
import { HierarchyGridPopover } from 'ui-component/customFormsComponents/HierarchySection/components';
import { TooltipTitle } from './TooltipTitle';
import { IRecordHeaders } from 'ui-component/records/types';
import { DataFocusViewButton } from '../../DataFocusViewButton';
import { RecordViewButton } from '../../RecordViewButton';

export type RenderPinnedMenuItemProps = {
    item: RecordGridActionsMenuItem;
    canPinMore: boolean;
    pinnedActions: string[];
    onAction: (action: RecordGridActionsAction) => (e: React.MouseEvent<HTMLLIElement>) => void;
    hasChildrenOrParent: boolean;
    record: IRecordHeaders;
    onUpdate: (updatedRecord: IRecordHeaders) => void;
};

export const RenderPinnedMenuItem = ({
    item,
    canPinMore,
    pinnedActions,
    onAction,
    hasChildrenOrParent,
    record,
    onUpdate
}: RenderPinnedMenuItemProps) => {
    if (item.id === 'DYNAMIC_DATA_FOCUS_VIEW')
        return <DataFocusViewButton recordId={record.id} recordType={record.recordType} onUpdate={onUpdate} />;
    if (item.id === 'RECORD_VIEW') return <RecordViewButton recordId={record.id} recordType={record.recordType} onUpdate={onUpdate} />;
    if (item.id === 'HIERARCHY') return <HierarchyGridPopover record={record} hasChildrenOrParent={hasChildrenOrParent} />;

    return (
        <Tooltip
            key={item.id}
            placement="top"
            arrow
            title={<TooltipTitle label={item.label} description={item.description} />}
            disableHoverListener={!(!canPinMore && !pinnedActions.includes(item.id))}
        >
            <IconButton size="small" onClick={() => onAction(item.id)} sx={{ width: 20, height: 20 }}>
                {item.icon}
            </IconButton>
        </Tooltip>
    );
};
